import {Asset, Folder} from '../../../Assets.types';

/**
 * Immutably update an asset in the tree
 * @param assetTree - The tree structure
 * @param assetId - ID of the asset to update
 * @param updates - Partial asset updates
 * @returns New tree with updated asset
 */
export default function updateAssetInTree(
  assetTree: Folder | null,
  assetId: number,
  updates: Partial<Asset>,
): Folder | null {
  if (!assetTree) {
    return null;
  }

  function updateFolderAssets(folder: Folder): Folder {
    // Check if this folder contains the asset
    const updatedAssets = folder.assets?.map((asset) => {
      if (asset.id === assetId) {
        return {
          ...asset,
          ...updates,
        };
      }

      return asset;
    });

    // Recursively update nested folders
    const updatedFolders = folder.folders?.map(updateFolderAssets);

    return {
      ...folder,
      assets: updatedAssets,
      folders: updatedFolders,
    };
  }

  return updateFolderAssets(assetTree);
}

